import { render, staticRenderFns } from "./iCcard.vue?vue&type=template&id=268c0c07&scoped=true&"
import script from "./iCcard.vue?vue&type=script&lang=js&"
export * from "./iCcard.vue?vue&type=script&lang=js&"
import style0 from "./iCcard.vue?vue&type=style&index=0&id=268c0c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c0c07",
  null
  
)

export default component.exports